import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchHarvestProcesses(organization_id) {
    return RequesterV1.get(
      `organization/process/packing/list_processes/${organization_id}/fetch_harvest_processes`
    );
  }
};
